/* TZ-safe conversion between the wire format ("yyyy-MM-dd") and a JS Date.
 * Calendar dates round-trip through DateOnly? on the backend, so we must
 * never let a Date go through toISOString() — always construct with the
 * local-date ctor so midnight stays in the user's TZ regardless of offset.
 *
 * Kept in a dedicated file so the two picker components (single + range)
 * can share them without tripping react-refresh/only-export-components on
 * mixed exports from a component module.
 */

export function ymdToLocalDate(ymd) {
    if (!ymd) return undefined;
    const [y, m, d] = ymd.split('-').map(Number);
    return new Date(y, m - 1, d);
}

export function localDateToYmd(date) {
    if (!date) return '';
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
}

export function formatDdMmYyyy(ymd) {
    const d = ymdToLocalDate(ymd);
    if (!d) return '';
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    return `${dd}/${mm}/${d.getFullYear()}`;
}
